<template>
  <div class="bubble">
    <el-button class="bubble-content" v-popover:popover1 @click="visible = !visible"></el-button>
    <el-button class="bubble-content" v-popover:popover2 @click="scroll"></el-button>
    <!-- <el-button class="bubble-content" v-popover:popover3 @click="jump(3)"></el-button>
    <el-button class="bubble-content bubble-content-last" v-popover:popover4></el-button>-->
    <el-popover
      ref="popover1"
      placement="left-start"
      trigger="manual"
      v-model="visible"
      popper-class="pop_phone"
    >
      <div class="pop_phone_label">
        <h2>快速服务通道</h2>
        <el-form class="pop_phone_form" ref="form" :model="form" :rules="rules" label-width="12px">
          <el-form-item prop="formType">
            <el-select v-model="form.formType" placeholder="请选择业务类型" style="width:100%">
              <el-option label="商标咨询" value="商标咨询"></el-option>
              <el-option label="版权咨询" value="版权咨询"></el-option>
              <el-option label="专利咨询" value="专利咨询"></el-option>
              <el-option label="其他服务" value="其他服务"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="phone">
            <el-input v-model="form.phone" placeholder="请填写联系方式"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="form.address" placeholder="请填写详细需求(选填)"></el-input>
          </el-form-item>
          <el-form-item>
            <p class="pop_phone_sub" @click="sub('form')">立即电话咨询</p>
          </el-form-item>
        </el-form>
      </div>
    </el-popover>
    <!-- <el-popover ref="popover2" placement="left-start" trigger="hover" popper-class="pop_sp">
      <div class="pop_label" @click="jump(2)">在线客服</div>
    </el-popover>
    <el-popover ref="popover3" placement="left-start" trigger="hover" popper-class="pop_sp">
      <div class="pop_label" @click="jump(3)">场景化咨询</div>
    </el-popover>
    <el-popover ref="popover4" placement="left-start" trigger="hover" popper-class="pop_wx">
      <div
        style="display:flex;justify-content: center;align-items: center;flex-direction: column;width:190px"
      >
        <img src="../assets/banner/banner-2.jpg" style="height:70px;width:70px;margin-top:10px" />
        <p style="width:70px;text-align:center">微信小程序</p>
        <img src="../assets/banner/banner-3.jpg" style="height:70px;width:70px;margin-top:5px" />
        <p style="width:70px;text-align:center">微信公众号</p>
      </div>
    </el-popover>-->
  </div>
</template>
<script>
	import checkPhone from '../fetch/checkPhone';
	import '../fetch/formatDate';
export default {
  data() {
    return {
      visible: false,
      isShow: false,
      scrollTop: 0,
      form: {
        formType: "",
        phone: "",
        address: "",
      },
      rules: {
        formType: [
          {
            required: true,
            message: "请选择服务类型",
            trigger: "change"
          }
        ],
        phone: [
          {validator: checkPhone, trigger: 'blur'}
        ]
      }
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.visible = true;
  },
  methods: {
    sub(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.http.post('IPR_Need',{
			  content:this[formName].formType + ',' + this[formName].address,
			  phone :this[formName].phone,
			  type: 5,
			  name:'快速服务通道测试人员' ,
			  date_time: new Date().format("yyyy-MM-dd hh:mm:ss"),
		  }).then(res => {
		  	if(res.code == 0){
		  		this.$emit('showTipsEvent', true)
				this.form.formType = ''
				this.form.phone = ''
				this.form.address = ''
		  	  
		  	}
		  })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleScroll() {
      this.scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (this.scrollTop >= 100) {
        this.isShow = true;
      } else {
        this.isShow = false;
      }
    },
    scroll() {
      let top = this.scrollTop;
      let step = Math.floor(top / 20);
      let timer = null;
      timer = setInterval(() => {
        if (top <= 0) clearInterval(timer);
        top -= step;
        window.scrollTo(0, top);
      }, 10);
    },

    jump(val) {
      if (val == 1) {
        if (this.$store.getters.userId) {
          if (this.$route.path.indexOf("myCenter") < 0) {
            let routeUrl = this.$router.resolve({
              path: "/myCenter/informat"
            });
            window.open(
              location.pathname + "#" + routeUrl.resolved.fullPath,
              "_blank"
            );
          }
        } else {
          this.$confirm("未登陆，请先登陆?", "提示", {
            confirmButtonText: "确定",
            showCancelButton: false,
            type: "warning"
          });
        }
      }
      if (val == 2) {
        // this.$router.push({ path: "" });
        let routeUrl = this.$router.resolve({
          path: "/customer_service",
          query: {
            user_id: 2,
            user_name: "小明"
          }
        });
        window.open(
          location.pathname + "#" + routeUrl.resolved.fullPath,
          "_blank"
        ); //线上发布用
        // window.open(
        //   "http://localhost:8080/" + "#" + routeUrl.resolved.fullPath,
        //   "_blank"
        // ); //开发测试用
      }
      if (val == 3) {
        // this.$router.push({ path: "" });
        let routeUrl = this.$router.resolve({
          path: "/intellect_consultation_page",
          query: {
            content: ""
          }
        });
        window.open(
          location.pathname + "#" + routeUrl.resolved.fullPath,
          "_blank"
        ); //线上发布用
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.bubble {
  position: fixed;
  top: 555px;
  right: 5px;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: url("../assets/sidebar/intell-bubble.png") center no-repeat;
  width: 80px;
  height: 326px;

  .bubble-content {
    width: 46px;
    height: 46px;
    border: 0;
    position: absolute;
    left: 7px;
  }

  .bubble-content:nth-of-type(1) {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    background: url("../assets/sidebar/tel_icon02.png") center no-repeat;
    border: 0;
    position: absolute;
    top: 125px;
    left: 5px;

    &:hover {
      background: url("../assets/sidebar/tel_icon01.png") center no-repeat;
    }
  }

  .bubble-content:nth-of-type(2) {
    background: url("../assets/sidebar/intell-slide-up.png") center no-repeat;
    top: 229px;

    &:hover {
      background: url("../assets/sidebar/intell-slide-up.png") center no-repeat;
    }
  }

  .bubble-content:nth-of-type(3) {
    background: url("../assets/sidebar/icon02-1.png") center no-repeat;
    top: 225px;

    &:hover {
      background: url("../assets/sidebar/icon02.png") center no-repeat;
    }
  }

  .bubble-content:nth-of-type(4) {
    background: url("../assets/sidebar/icon03-1.png") center no-repeat;
    top: 271px;

    &:hover {
      background: url("../assets/sidebar/icon03.png") center no-repeat;
    }
  }

  .bubble-top {
    position: fixed;
    bottom: 1rem;
    border: 0;

    &:hover {
      background: #666;
    }
  }
}

.pop_sp {
  min-width: 0;
  /* background: #f47227; */
}

.pop_wx {
  padding: 0;
}

.pop_label {
  color: #fff;
  font-size: 16px;
  width: 100px;
  text-align: center;
  color: #606266;
}

.pop_phone {
  padding: 0;
  margin: 0;
  width: 240px;
  height: 315px;
  padding: 20px 12px;
  box-sizing: border-box;
}

.pop_phone_label {
  /* width:240px;
  height:280px;
  padding: 12px;
  box-sizing: border-box; */
}

.pop_phone_label h2 {
  font-size: 20px;
  font-family: Alibaba PuHuiTi;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  text-align: center;
  margin: 0;
  padding: 0;
}

.pop_phone_label .el-form-item {
  margin-bottom: 14px;
}

.pop_phone_label {
  /deep/.el-form-item__error {
    padding: 0;
  }
}

.pop_phone_form {
  margin-top: 20px;
  padding-right: 12px;
}

.pop_phone_sub {
  margin: 0;
	padding: 0;
	margin-top: 10px;
  height: 40px;
  width: 100%;
  background: rgba(244, 114, 39, 1);
  border-radius: 5px;
  font-size: 16px;
  font-family: Alibaba PuHuiTi;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  text-align: center;
}

.pop_phone_sub:hover {
  cursor: pointer;
}

.el-popover {
  border: 0;
}

.pop_sp[x-placement^="left"] .popper__arrow::after {
  /* border-left-color: #f47227; */
}

.el-popover:hover {
  cursor: pointer;
}
</style>
